module.exports = __webpack_public_path__ + "img/convenio-faculdades.cd9f2d3a.png";